const initialState = {
  loaded: false,
  data: {},
}

export default initialState
